/**
 * Collection of easing curves used throughout the application.
 */
export const easings = {
    elastic: "cubic-bezier(0.40,1.01,0.32,1.05)",
    inOutCubic: "cubic-bezier(0.645, 0.045, 0.355, 1)",
    inOutQuad: "cubic-bezier(0.455, 0.03, 0.515, 0.955)",
    inOutQuart: "cubic-bezier(0.77, 0, 0.175, 1)",
    inOutQuint: "cubic-bezier(0.86, 0, 0.07, 1)",
    outQuart: "cubic-bezier(0.165, 0.84, 0.44, 1)",
    veryElastic: "cubic-bezier(0.45,0.35,0.3,1.2)",
};
